export const fields = [
  { label: 'Email', value: 'email', disabled: true },
  { label: 'Password', value: 'password', disabled: true },
  { label: 'Confirm Password', value: 'confirmPassword', disabled: true },
  { label: 'Username', value: 'username' },
  { label: 'First Name', value: 'firstName', disabled: true },
  { label: 'Last Name', value: 'lastName', disabled: true },
  { label: 'Date of Birth', value: 'dateOfBirth', disabled: true },
  { label: 'Address', value: 'address', disabled: true },
  { label: 'Phone', value: 'phone' },
  { label: 'Gender', value: 'gender', disabled: true },
  { label: 'Preferred Language', value: 'preferredLanguage' },
  { label: 'Country', value: 'countryCode', disabled: true },
  { label: 'News Letter', value: 'newsLetter' },
  { label: 'Currency Code', value: 'currencyCode', disabled: true },
  { label: 'SMS', value: 'sms' }
]
